<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Cambio"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-header-image image="images/cambio-header.jpg" />
      <o-section-header title="Overzicht reservatie" />
      <o-section>
        <p>Je wijziging kan worden doorgevoerd:</p>
      </o-section>
      <o-section>
        <o-key-value label="Locatie" value="Gent" />
        <o-key-value label="Standplaats" value="Gent-Dampoort" />
        <o-key-value label="Wagenklasse" value="S Micro. autom. - 2 + 2 pl." />
        <o-key-value label="Vertrek" value="24/06/2019 - 11:00" />
        <o-key-value label="Aankomst" value="24/06/2019 - 17:00" />
        <o-key-value label="Reikweidte" value="25 km" />
        <o-key-value label="Verzekering" value="Volledige dekking" />
      </o-section>
      <o-section>
        <o-text-input placeholder="Schrijf hier je persoonlijke referentie" />
      </o-section>
    </o-view>
    <o-pay-button label="Bevestig wijziging" to="/sales/car/cambio" />
  </o-view>
</template>

<script>
import OFavoriteToggle from '@/components/OFavoriteToggle.vue'
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioEditSummary',
  components: {
    OFavoriteToggle,
    OHeaderImage,
    OPayButton
  },
  data() {
    return {
      showInfoOverlay: false,
      showSupportOverlay: false
    }
  },
  methods: {
    toggleInfoOverlay() {
      this.showInfoOverlay = !this.showInfoOverlay
    },
    toggleSupportOverlay() {
      this.showSupportOverlay = !this.showSupportOverlay
    },
    closeAllOverlays() {
      this.showInfoOverlay = false
      this.showSupportOverlay = false
    }
  }
}
</script>
